import { Input, KeyCode } from "../../lib/Input";
import SPAbility from "../SPAbility";
import SPBogey from "../SPBogey";
import SPPlayer from "../SPPlayer";

export default class SPCountercharge extends SPAbility {
    constructor(player: SPPlayer) {
            super(player, {
                cooldown: 15,
                duration: 5,
                icon: 5,
                trigger: KeyCode.Digit1,
                triggerType: Input.GetKeyDown
            });
        }

        listener = ({amt, options}: {
            amt: number;
            options: {
                bypassExp?: boolean;
                attacker?: SPBogey;
            };
        }) => {
            if (options.attacker) {
                options.attacker.Damage(amt);
            }
        }

        onDurationEnd(): void {
            this.player.events.off("on-damage", this.listener);
        }

        onUse(): void {
            this.player.events.on("on-damage", this.listener);
        }
}